<template>
  <ServerDataTable
    ref="rolesTable"
    :columns="columnas"
    :fetchData="consultarRoles"
    :extraParams="{}"
    rowKey="id"
    initialSortField="nombre"
    initialSortDirection="asc"
    titulo="Roles"
    :borrados="true"
  >
    <template #header-actions>
      <p @click="abrirAltaRol"><i class="fa fa-plus" aria-hidden="true"></i></p>
    </template>

    <template #acciones="{ row }">
      <div class="acciones-rol">
        <a v-if="!row.deleted_at" href="#" class="cursor-pointer me-3" data-bs-toggle="tooltip" title="Editar Rol" @click.prevent="abrirEditarRol(row)">
          <i class="fas fa-user-edit text-analiza-dark"></i>
        </a>
        <a v-if="puedeMostrarBotonEliminar(row)" href="#" class="cursor-pointer" data-bs-toggle="tooltip" title="Eliminar Rol" @click.prevent="mostrarConfirmacionBorrar(row.id)">
          <i class="fas fa-trash text-analiza-dark"></i>
        </a>
      </div>
    </template>
  </ServerDataTable>

  <Modal @cerrar-modal="cerrarModal" :modalActive="modalActive">
    <div class="modal-content">
      <alta-rol-form
        v-if="tipoModal == 'A'"
        :key="0"
        @cerrar-modal="onRolGuardado"
      ></alta-rol-form>
      <edita-rol-form
        v-if="tipoModal == 'E'"
        :key="rolEditId"
        :rolId="rolEditId"
        :rolNombre="rolEditNombre"
        :rolPermisos="rolEditPermisos"
        :puedeEditar="buscaPermiso('edit-usuarios')"
        @cerrar-modal="onRolGuardado"
      ></edita-rol-form>
    </div>
  </Modal>

  <div v-if="confirmacionVisible" class="overlay">
    <div class="confirm-box">
      <p class="mt-4 mb-4">{{ mensajeConfirmacion }}</p>
      <table class="mt-4 mb-4">
        <tbody>
          <tr>
            <td width="50%"><button class="btn-cancela" @click="cancelacion">Cancelar</button></td>
            <td width="50%"><button class="btn-confirma" @click="confirmacion">Confirmar</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import Modal from "./components/Modal.vue";
import AltaRolForm from "./components/AltaRolForm.vue";
import EditaRolForm from "./components/EditaRolForm.vue";
import ServerDataTable from "@/views/components/ServerDataTable.vue";
import { globalFunctionsMixin } from "@/mixins/globalFunctions.js";

export default {
  name: "Roles",
  components: {
    ServerDataTable,
    Modal,
    AltaRolForm,
    EditaRolForm
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      confirmacionVisible: false,
      rolId: 0,
      mensajeConfirmacion: "",
      tipoModal: "",
      rolEditId: 0,
      rolEditNombre: "",
      rolEditPermisos: [],
      modalActive: false
    };
  },

  computed: {
    columnas() {
      return [
        { key: "nombre", label: "Nombre", sortable: true },
        {
          key: "usuarios",
          label: "Núm.Usuarios",
          sortable: true,
          format: (value) => `${value ?? 0}`
        },
        {
          key: "permisos",
          label: "Núm.Permisos",
          sortable: false,
          format: (value) => `${Array.isArray(value) ? value.length : 0}`
        },
        { key: "no_usar", label: "Inactivo", sortable: true, format: "boolean" },
        { key: "created_at", label: "Creado", sortable: true, format: "date" },
        { key: "deleted_at", label: "Eliminado", sortable: true, format: "date", indicaBaja: true },
        { key: "acciones", label: "Acciones", sortable: false, slot: "acciones" }
      ];
    }
  },

  methods: {
    mostrarConfirmacionBorrar(id) {
      this.confirmacionVisible = true;
      this.rolId = id;
      this.mensajeConfirmacion = "¿Confirma que desea eliminar este rol?";
    },
    confirmacion() {
      this.confirmacionVisible = false;
      this.borrarRol(this.rolId);
    },
    cancelacion() {
      this.confirmacionVisible = false;
    },
    async consultarRoles(params) {
      try {
        const response = await this.$store.dispatch("auth/roles", {
          textoBuscador: params.search,
          pagina: params.page,
          perPage: params.pageSize,
          sortField: params.sortField,
          sortDirection: params.sortDirection,
          mostrarBorrados: params.mostrarBorrados
        });

        const rows = Array.isArray(response?.rows) ? response.rows : [];

        return {
          rows,
          total: Number(response?.total ?? rows.length),
          page: Number(response?.page ?? params.page),
          pageSize: Number(response?.pageSize ?? response?.perPage ?? params.pageSize)
        };
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Se ha producido un error",
          width: 500
        });

        return {
          rows: [],
          total: 0,
          page: params.page,
          pageSize: params.pageSize
        };
      }
    },
    abrirAltaRol() {
      this.modalActive = true;
      this.tipoModal = "A";
      this.rolEditId = 0;
      this.rolEditNombre = "";
      this.rolEditPermisos = [];
    },
    abrirEditarRol(row) {
      this.modalActive = true;
      this.tipoModal = "E";
      this.rolEditId = row.id;
      this.rolEditNombre = row.nombre;
      this.rolEditPermisos = row.permisos;
    },
    puedeMostrarBotonEliminar(row) {
      return !(row.deleted_at && this.buscaPermiso("edit-usuarios"));
    },
    async borrarRol(rolId) {
      try {
        const resp = await this.$store.dispatch("auth/borraRol", { id: rolId });

        if (resp.res == "OK") {
          showSwal.methods.showSwal({
            type: "success",
            message: resp.mensaje,
            width: 600
          });
          this.refrescarTabla();
        } else {
          showSwal.methods.showSwal({
            type: "error",
            message: resp.mensaje,
            width: 500
          });
        }
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Se ha producido un error",
          width: 500
        });
      }
    },
    cerrarModal() {
      this.modalActive = false;
    },
    onRolGuardado() {
      this.modalActive = false;
      this.refrescarTabla();
    },
    refrescarTabla() {
      this.$refs.rolesTable?.refresh();
    },
    irInicio() {
      this.$router.push("/profile");
    }
  },

  async beforeMount() {
    this.$store.state.showSidenav = true;
    if (!this.$store.state.profile.permisos) {
      await this.$store.dispatch("profile/getPermisos");
    }
  },
};
</script>

<style lang="scss" scoped>
.roles {
  background-color: rgba(0, 176, 234, 0.5);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .modal-content {
    display: flex;
    flex-direction: column;

    h1,
    p {
      margin-bottom: 16px;
    }

    h1 {
      font-size: 32px;
    }

    p {
      font-size: 18px;
    }
  }
}

.acciones-rol {
  display: flex;
  align-items: center;
  min-width: 72px;
}
</style>
